<template>
	<div class="">
		<vm-header></vm-header>
		<v-Massage1></v-Massage1>
		<saixuantop2></saixuantop2>
		<v-crumbs></v-crumbs>
		<div class="btn-last">
			<button type="button" @click="tijiao">提交</button>
		</div>
		<item7></item7>
	</div>
</template>

<script>
	import vmHeader from '../../components/vmHeader.vue'
	import item7 from '../../components/item7.vue'
	import vMassage1 from '../../components/vMassage1.vue'
	import vCrumbs from '../../components/vCrumbs.vue'
	import saixuantop2 from '../../components/saixuantop2.vue'
	export default {
		name: "",
		components: {
			vMassage1,
			vmHeader,
			item7,
			vCrumbs,
			saixuantop2
		},
		data() {
			return {}
		},
		methods: {
			tijiao(){
				this.$router.push('/zhinengxuankejieguoye')
			},
		}


	}
</script>

<style scoped>
	.btn-last{
		margin-top: 40px;
		display: flex;
		justify-content: center;
	}
	.btn-last button{
		border: none;
		font-size: 18px;
		color: white;
		width: 324px;
		height: 52px;
		background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
		opacity: 1;
		border-radius: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/g_zhinengxuanke.vue